import React, { useCallback, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Tooltip } from "antd";

// api
import { campaignList } from "../../../api/apiClients/campaign";

// assets
import { images } from "../../../assets/images/index";

// constants
import {
  CAMPAIGN_TYPE,
  SORT,
  STATUS
} from "../constants/campaignList";

// hooks
import { useSearch } from "hooks/useSearch";
import useToggle from "hooks/useToggle";

// redux
import { useAspSelector } from "../../../test/jest-redux-hooks";

// components
import { ICONS } from "../../../assets/icons";
import CreateCampaignModal from "../../../components/commonComponents/campaigns/CreateCampaignModal";
import CampaignsListContainer from "../components/campaigns/CampaignsListContainer";

let page = 1;
let limit = 10;

const goalTypeConvertion = {
  engagement: 1,
  leads: 2,
  awareness: 3,
  sales: 4,
};

const campaignTypeConvertion = {
  "time-specified": 2,
  perpetual: 3,
};

export default function CampaignsList() {
  const { goalType } = useParams();
  const location = useLocation();
  const { currentBrand } = useAspSelector((state) => state.app);

  const [list, setList] = useState(null);
  const [isLoading, setIsLoading] = useToggle(false);
  const [isFilters, setIsFilters] = useToggle(false);

  const [sort, setSort] = useState(null);
  const [sortLabel, setSortLabel] = useState("");

  const [type, setType] = useState(null);
  const [selectedTypes, setSelectedTypes] = useState(null);
  const [status, setStatus] = useState(null);
  const { searchKey, setSearchKey, onChange: onSearchChange } = useSearch("");
  const [isLoadingSkeleton, setIsLoadingSkeleton] = useToggle(false);
  const [isCreateCampaign, setIsCreateCampaign] = useToggle(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [statusTrue, setStatusTrue] = useState(false);

  useEffect(() => {
    setType(CAMPAIGN_TYPE);
    setStatus(STATUS);
    setSort(SORT);
  }, []);

  let data = {};
  sort?.map((s) => {
    if (s?.id === 1) {
      s?.options?.map((o) => {
        if (o?.isSelected) data["sort_by"] = o?.status;
      });
    }

    if (s?.id === 2) {
      s?.options?.map((o) => {
        if (o?.isSelected) data["order_by"] = o?.status;
      });
    }
  });

  useEffect(() => {
    if (data) {
      const payload = {
        page: page,
        limit: limit,
        name: searchKey,
        status: getSelectedStatus(),
        // sort_by: onSortChange(),
        campaign_type: selectedTypes || campaignTypeConvertion[goalType],
        goal_type: goalTypeConvertion[goalType],
        ...data,
      };

      getCampaignList(true, currentBrand?.brand_id, payload);
    }
  }, [
    currentBrand,
    goalType,
    status,
    sort,
    type,
    isCreateCampaign,
    searchKey,
    isModalOpen,
  ]);

  // API
  const getCampaignList = async (loading, brand_id, payload) => {
    // if (loading) setIsLoading(true);
    // else setIsFilters(true);
    if (loading) setIsLoadingSkeleton(true);
    try {
      const res = await campaignList(brand_id, payload);
      setIsLoadingSkeleton(false);
      setList(res?.data);
      setCount(res?.data?.campaigns_count);
    } catch (error) {
      console.warn(error);
    } finally {
      // if (loading) setIsLoading(false);
      // else setIsFilters(false);
      setIsLoadingSkeleton(false);
    }
  };

  const loadNextPage = async () => {
    setIsLoadingSkeleton(false);
    limit += 10;

    const payload = {
      page: page,
      limit: limit,
      name: searchKey,
      status: getSelectedStatus(),
      campaign_type: selectedTypes || campaignTypeConvertion[goalType],
      goal_type: goalTypeConvertion[goalType],
      ...data,
    };
    await getCampaignList(isLoading, currentBrand?.brand_id, payload);
  };

  const onSortChange = (id, data) => {
    const res = sort?.map((s) => {
      if (s.id === id) {
        const updatedOptions = s?.options?.map((o) => {
          if (o?.id === data?.id) return { ...o, isSelected: true };
          return { ...o, isSelected: false };
        });
        return { ...s, options: updatedOptions };
      } else {
        const updatedOptions = s?.options?.map((o) => {
          return { ...o, isSelected: false };
        });
        return { ...s, options: updatedOptions };
      }
    });

    const selectedOptions = res
      .flatMap((s) => s?.options)
      .filter((option) => option?.isSelected);
    setSortLabel(selectedOptions?.[0]?.label);

    setSort(res);
  };

  const clearSort = () => {
    const res = sort?.map((s) => {
      return { ...s, isSelected: false };
    });
    setSort(res);
  };

  // goal type filter
  const onTypeChange = (data) => {
    const res = type?.map((t) => {
      if (t?.id === data?.id) return { ...t, isSelected: !t?.isSelected };
      return t;
    });
    const filters = res?.filter((r) => r?.isSelected === true && r.id);
    const getFilteresId = filters?.map((f) => f?.id);
    setSelectedTypes(getFilteresId);
    setType(res);
  };

  const clearType = () => {
    const res = type?.map((t) => {
      return { ...t, isSelected: false };
    });
    setType(res);
    setSelectedTypes(null);
  };

  // status filter
  const onStatusChange = (data) => {
    const res = status?.map((s) => {
      if (s?.id === data?.id) return { ...s, isSelected: !s?.isSelected };
      return s;
    });
    setStatus(res);
    setStatusTrue(true);
  };

  const clearStatus = () => {
    const res = status?.map((t) => {
      return { ...t, isSelected: false };
    });

    setStatus(res);
    setStatusTrue(false);
  };

  const getSelectedStatus = useCallback(() => {
    const res = status?.filter((s) => s?.isSelected === true);
    const ids = res?.map((r) => r?.status);
    return ids?.length === STATUS?.length ? null : ids;
  }, [status]);

  // modals
  const onCreateCampaignModal = (data) => setIsCreateCampaign(data);

  return (
    <div className="w-full p-20 flex flex-col gap-10 pb-0 relative">
      <div className="w-100 flex items-center justify-between  my-7">
        <div className="w-[65%] flex-row align-center gap-5">
          <img src={images?.Flag} alt="flag" />
          <div className=" flex-column gap-2.5">
            <h2 className="text-3xl weight-semibold">Campaigns</h2>
            <p className="header-titles ">
              Define your business goals and create campaigns to achieve them.
              Reach your audience, boost engagement, and track results with
              ease.
            </p>
          </div>
        </div>
        {location?.pathname !== "/user/campaign/perpetual" && (
          <Tooltip 
            title={currentBrand?.brand_mode === 'test' && count >= 3 ? "In Test Mode you can't create more than 3 campaign" : ""}
            placement="top"
            overlayClassName="campaign-tooltip"
          >
            <div
              className={`flex-row align-center px-2 py-1.5 text-base weight-medium rounded-md border-2 ${currentBrand?.brand_mode === 'test' && count >= 3
                ? 'bg-gray-300 border-gray-300 text-gray-500 cursor-not-allowed' 
                : 'bg-[var(--new-primary)] border-[var(--new-primary)] text-white cursor-pointer'}`}
              onClick={() => {
                if (!(currentBrand?.brand_mode === 'test' && count >= 3)) {
                  onCreateCampaignModal(true);
                }
              }}
            >
              <img 
                src={ICONS?.CreateCampaignNew} 
                alt="Create" 
                className="pr-5" 
                style={currentBrand?.brand_mode === 'test' && count >= 3 ? { opacity: 0.5 } : {}}
              />
              <span>Create Campaign</span>
            </div>
          </Tooltip>
        )}
      </div>

      <CampaignsListContainer
        isLoading={isFilters}
        list={list?.campaigns}
        count={count}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        onSearchChange={onSearchChange}
        sort={sort}
        onSortChange={onSortChange}
        clearSort={clearSort}
        type={type}
        onTypeChange={onTypeChange}
        clearType={clearType}
        selectedTypes={selectedTypes}
        status={status}
        onStatusChange={onStatusChange}
        clearStatus={clearStatus}
        loadNextPage={loadNextPage}
        sortLabel={sortLabel}
        isLoadingSkeleton={isLoadingSkeleton}
        onCreate={() => onCreateCampaignModal(true)}
        isCreateCampaign={isCreateCampaign}
        setIsCreateCampaign={setIsCreateCampaign}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        statusTrue={statusTrue}
      />

      <CreateCampaignModal
        open={isCreateCampaign}
        setOpen={setIsCreateCampaign}
        type={"create"}
      />
    </div>
  );
}
